<template>
  <div class="min-h-60 max-h-96 flex md:flex-row">
    <div
      class="hidden md:block flex-none w-36 h-36 ml-16 my-auto overflow-hidden rounded-full bg-gray-400 mr-14 select-none"
    >
      <img class="w-full h-full" :src="avatar" alt="头像" />
    </div>
    <div
      class="flex-1 flex flex-row flex-wrap justify-center md:justify-start items-center px-2 md:px-20 max-h-full overflow-y-scroll py-4"
    >
      <button
        v-for="(option, index) in content.options"
        :key="index"
        :class="['button-primary', activeIndex === index ? 'activeBotton' : '']"
        @click="handleSelect(option)"
      >
        {{ option }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('common');

@Component
export default class UtteranceControl extends Vue {
  @Prop() content!: Content & {
    messages?: Array<string>;
    options: Array<string>;
    questionAvatar: string;
  };
  @Prop({ type: String }) currentAvatar!: string;
  @userModule.State('loading') public globalLoading!: boolean;

  activeIndex = 0;

  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence;
    return portalSequence[portalSequence.length - 1];
  }

  get avatar() {
    return this.content.questionAvatar || this.currentAvatar;
  }

  handleSelect(selected: string) {
    if (this.globalLoading) return;
    if (this.portalView) return this.$store.commit('common/popPortal');
    window.storyteller.input(selected);
    window.next();
    this.$emit('next');
  }

  onKeyboard() {
    document.addEventListener('keyup', this.onKeyPress, false);
  }

  onKeyPress(event: KeyboardEvent) {
    event.preventDefault();

    const selected = this.content.options[this.activeIndex];
    const optionLen = this.content.options.length;

    switch (event.code) {
      case 'Enter':
        this.$Message.info({
          time: 1500,
          content: '要先回答才能继续哦'
        });
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        this.activeIndex = (optionLen + this.activeIndex - 1) % optionLen;
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        this.activeIndex = (this.activeIndex + 1) % optionLen;
        break;
    }
  }

  mounted() {
    this.onKeyboard();
  }

  beforeDestroy() {
    document.removeEventListener('keyup', this.onKeyPress, false);
  }
}
</script>

<style scoped>
.button-primary {
  @apply min-w-96 text-center border rounded-md text-xl cursor-pointer mt-2 mx-2 py-4 px-2 bg-base hover:border-motif-500 active:bg-indigo-100 select-none;
}

.activeBotton {
  @apply border-motif-500 bg-motif-100;
}
</style>
